import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getAllCards } from '../tarot-data/cards'
import { useCardLocalizer } from '../i18n/useLocalized'
import { cardImage, clearDrawnCard, readDrawnCard } from './landing/landingUtils'
import './DrawnCardBanner.css'

/**
 * Greets a new member with the card they drew in the landing page's teaser,
 * so the question they held there carries into their first reading. Shown
 * once: starting the reading or dismissing it forgets the card.
 */
const DrawnCardBanner = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const localize = useCardLocalizer()
    const [cardId, setCardId] = useState(readDrawnCard)

    const raw = cardId === null ? null : getAllCards().find((c) => c.id === cardId)
    if (!raw) return null
    const card = localize(raw)

    const forget = () => {
        clearDrawnCard()
        setCardId(null)
    }

    const begin = () => {
        forget()
        navigate('/dash/spread/one-card')
    }

    return (
        <aside className="drawn-banner" aria-label={t('dash.drawnCard.eyebrow')}>
            <img
                className="drawn-banner__card"
                {...cardImage(card.filename, '64px')}
                alt={card.name}
                width="320"
                height="533"
            />
            <div className="drawn-banner__body">
                <p className="drawn-banner__eyebrow">{t('dash.drawnCard.eyebrow')}</p>
                <p className="drawn-banner__text">{t('dash.drawnCard.text', { card: card.name })}</p>
                <button type="button" className="drawn-banner__cta" onClick={begin}>
                    {t('dash.drawnCard.cta')}
                    <span aria-hidden="true"> &#8594;</span>
                </button>
            </div>
            <button
                type="button"
                className="drawn-banner__dismiss"
                onClick={forget}
                aria-label={t('dash.drawnCard.dismiss')}
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </aside>
    )
}

export default DrawnCardBanner
